import { WebReportEvent } from '@slardar/sdk-web';
import ChromeExtensionPlugin from './plugins/chrome-extension-plugin';
import EmptyErrorStackPlugin from './plugins/empty-error-stack-plugin';
import ErrorMissNamePlugin from './plugins/error-miss-name-plugin';
import NetworkPlugin from './plugins/network-plugin';
import ResourceErrorPlugin from './plugins/resource-error-plugin';
import ServiceWorkerPlugin from './plugins/service-worker-plugin';
import ThirdLibErrorPlugin from './plugins/third-lib-error-plugin';
import FallbackPlugin from './plugins/fallback-plugin';
import BasePlugin from './plugins/base-plugin';

export default class DefaultBeforeSend {
  handler?: BasePlugin;

  buildInModules: (new () => BasePlugin)[] = [
    ErrorMissNamePlugin,
    ServiceWorkerPlugin,
    NetworkPlugin,
    ChromeExtensionPlugin,
    EmptyErrorStackPlugin,
    ResourceErrorPlugin,
    ThirdLibErrorPlugin,
    FallbackPlugin,
  ];

  init(externalModules?: (new () => BasePlugin)[]) {
    const modules = (externalModules || []).concat(this.buildInModules);
    // build handler link
    let baseHandler = this.handler;
    modules.forEach(HandlerModule => {
      if (!baseHandler) {
        baseHandler = new HandlerModule();
        this.handler = baseHandler;
      } else {
        baseHandler = baseHandler.setNext(new HandlerModule());
      }
    });
  }

  beforeSend(event: WebReportEvent) {
    // if handled by other handler, ignore it
    if (
      event.ev_type === 'js_error' &&
      /^\[(info|error|warn|fatal)\]/.test(event.payload.error.name || '')
    ) {
      return event;
    }
    return this.handler ? this.handler.handleErrorEvent(event) : event;
  }
}
